import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { ExportExcelButton } from 'components/ExportExcelButton/ExportExcelButton';
import { formatPhoneNumber } from 'shared/formatters';

const Container = styled.button`
  border-radius: 5px;
  background-color: #fa4616;
  color: #fff;
  box-sizing: border-box;
  padding: 15px;
  border: none;
  width: calc(100% - 20px);
  margin: 0 10px 0 10px;

  &:focus {
    outline: none;
  }

  @media (min-width: 860px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 10px 0 10px;
    background-color: transparent;
    cursor: pointer;
    width: auto;
  }
`;

function download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute(
    'href',
    'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
  );
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

function renderGuests(guests, guestType) {
  return guests
    .map((guest) => {
      const { last_name, first_name, phone_number, additional_guests } = guest;
      return `"${last_name}, ${first_name}","${formatPhoneNumber(
        phone_number
      )}","${additional_guests}","${guestType}"`;
    })
    .join('\n');
}

const exportCvs = ({ guests, event }) => {
  const csv = `${
    event.start_date ? moment(event.start_date).format('MMM DD') : null
  } ${
    event.end_date ? `- ${moment(event.end_date).format('MMM DD, YYYY')}` : null
  } - ${event.name},,
Name, Phone Number, Additional Guests, Guest Type
${renderGuests(guests.event_guests, 'Single Event')}
${renderGuests(guests.yearly_guests, 'Yearly')}
`;

  download('GuestList.csv', csv.trim());
};

const Export = ({ ...props }) => {
  return (
    <Container onClick={() => exportCvs(props)}>
      <ExportExcelButton />
    </Container>
  );
};

export default Export;
